<template>
	<div class="container raiting"
	     ref="raiting">
		<div class="noinfo"
		     v-if="error">
			<span>Топ 20 каналов</span>
			<span>Отсутствует информация</span>
			<span>Не удачный запрос к серверу</span>
		</div>
		<preloader v-if="preloaderValue"/>
		<label for="select"></label>
		<select name="" id="select" v-model="rangeNum">
			<option :value="1">за день</option>
			<option :value="7">за неделю</option>
			<option :value="30">за месяц</option>
		</select>
		<div id="chartContainer_rating"></div>
		<table class="table" ref="table">
			<tr v-for="(t, i) in tmp"
			    :key="i">
				<td>{{t.label}}</td>
				<td>{{t.y}} %</td>
			</tr>
		</table>
	</div>
</template>
<script>
	import { performRequest } from "../script/ws/wsclient";
	import { mapGetters }     from "vuex";
	import Preloader          from "./Preloader";

	export default {
		data() {
			return {
				preloaderValue: true,
				error:          false,
				tmp:            [],
				test:           0,
				chartList:      {},
				container:      null,
				range:          "за неделю",
				rangeNum:       7
			};
		},
		components: { Preloader },
		mounted() {
			this.container = this.$refs.raiting;
			this.initGraph();
			this.gistG();
		},
		computed:   {
			...mapGetters(["getChartContainerDay", "getViewUser"])
		},
		methods:    {
			initGraph() {
				let chart             = new CanvasJS.Chart("chartContainer_rating", {
					zoomEnabled:     true,
					exportEnabled:   true,
					backgroundColor: "rgb(184, 200, 209)",
					theme:           "light2",
					width:           this.container.clientWidth,
					height:          this.container.clientWidth * 9 / 20 - 20,
					title:           {
						text:     `Top 20 телеканалов ${this.range}`,
						fontSize: 14
					},
					axisX:           {
						labelAutoFit: false,
						labelAngle:   -45,
						interval:     1
					},
					axisY:           {
						title:          "рейтинг, %",
						labelFormatter: function () {
							return "";
						}
					},
					data:            [
						{
							type:         "column",
							bevelEnabled: true,
							indexLabel:   `{y} %`,
							dataPoints:   null
						}
					]
				});
				chart.name            = "rating";
				this.chartList.rating = chart;
			},
			gistG() {
				let table           = this.$refs.table;
				let container       = this.$refs.raiting;
				this.tmp            = [];
				this.preloaderValue = true;
				performRequest(
					{
						section: "iptvlog",
						name:    "getStreamRaiting"
					},
					{
						dateTo:   Math.floor(Date.now() / 1000),
						dateFrom: Math.floor(Date.now() / 1000) - 60 * 60 * 24 * this.rangeNum,
						operator: this.getViewUser
					},
					a => {
						if (a.code === 200) {
							this.error             = false;
							this.preloaderValue    = false;
							container.style.height = `${container.clientWidth * 9 / 20}px`;
							table.style.top        = `${container.clientWidth * 9 / 20}px`;
							this.onResponse(a);
						} else {
							this.error          = true;
							this.preloaderValue = false;
						}
					}
				);
			},
			onResponse(a) {
				let json    = [];
				let maxTime = 0;
				let tmp     = this.tmp;
				a.data.forEach(item => {
					let t   = {};
					t.label = item.stream;
					t.y     = item.duration;
					tmp.push(t);
				});

				tmp.forEach(item => {
					maxTime += item.y;
				});
				tmp.forEach(item => {
					item.y   = Math.round(item.y * 10000 / maxTime) / 100;
					item.val = item.y;
					if (item.y > 0) {
						if (json.length >= 20) {
							return;
						}
						json.push(item);
					}
				});
				this.chartList["rating"].options.data[0].dataPoints = json;
				this.chartList["rating"].render();
			}
		},
		watch:      {
			rangeNum(vnew) {
				if (vnew === 1) {
					this.range = "за день";
				} else if (vnew === 7) {
					this.range = "за неделю";
				} else if (vnew === 30) {
					this.range = "за месяц";
				}
				this.initGraph();
				this.gistG();
			}
		}
	};
</script>
<style scoped lang="scss">
	$width: 90%;
	.container {
		padding: 0;
		position: absolute;
		display: flex;
		flex-direction: column;
		margin-top: 4rem;
		width: $width;
		height: $width  * 9 / 20;
		max-width: 1024px;
		left: 50%;
		transform: translateX(-50%);
		select {
			margin-bottom: 5px;
		}
		table {
			position: absolute;
			width: 100%;
			margin-bottom: 50px;
			margin-top: 15px;
			tr {
				background-color: rgba(255, 255, 255, 0.78);
				transition: all 0.3s;
				cursor: default;
				margin-bottom: 20px;
				font-size: 16px;
				&:hover {
					background-color: rgba(201, 255, 203, 0.79);
				}
				td {
					border: 1px solid #ccc;
					text-align: center;
					padding-bottom: 2px;
				}
				
			}
		}
		p {
			position: absolute;
			z-index: 1000;
			width: 3rem;
			height: 3rem;
			border-radius: 50%;
			background-color: rgb(142, 255, 153);
			cursor: pointer;
			opacity: 0;
			left: -1rem;
			top: -1rem;
			font-weight: bold;
			text-align: center;
			line-height: 2.9rem;
			font-size: 3rem;
			box-shadow: 0 0 1rem #000, inset 0 0 3px #000;
			animation: pulse 1s ease infinite;
			transition: opacity 0.5s;
		}
		.noinfo {
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			width: 45rem;
			height: 20rem;
			display: flex;
			flex-direction: column;
			justify-content: center;
			color: #940000;
			span {
				height: 30px;
				font-size: 1.2rem;
				text-align: center;
			}
		}
		
		&:hover > p {
			opacity: 1;
		}
		
		@keyframes pulse {
			0% {
				transform: scale(1);
			}
			
			50% {
				transform: scale(1.1);
			}
			
			100% {
				transform: scale(1);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/streamRating.vue